/**
 * Judge.me star badge -> review widget scroll (2026-08-03).
 *
 * On Dawn, clicking the star rating under the product title jumped to the reviews.
 * On New Horizon it did nothing, even after the Review Widget block was restored to
 * the design-online template.
 *
 * Cause (read from the live page, not assumed): Judge.me dresses the badge as a
 * control — `role="button"`, `tabindex="0"`, `cursor: pointer` — and its own config
 * carries `scrollTopOffset: 30`, but `jdgmSettings.scrollTo` is an EMPTY OBJECT, so
 * their handler has no registered target and silently does nothing. That map is app
 * side; the theme cannot populate it, and no Judge.me admin setting exposes it.
 *
 * The target itself is present and stable: the Review Widget renders
 * `#judgeme_product_reviews`. So this supplies the missing behaviour and nothing else.
 *
 * Notes:
 * - Delegated on document, because Judge.me injects and re-renders the badge
 *   asynchronously; binding directly would race its own rendering.
 * - No-ops when either the badge or the widget is absent, so it is inert on every
 *   page that has no reviews block, and inert again if Judge.me ever ships its own
 *   working handler (their handler would scroll first; ours would then be a
 *   redundant scroll to the same place).
 * - Honours prefers-reduced-motion.
 * - Offsets by the sticky header so the widget heading is not hidden underneath it.
 */
(function () {
  var WIDGET_SELECTOR = '#judgeme_product_reviews, .jdgm-rev-widg';
  var BADGE_SELECTOR = '.jdgm-prev-badge, .jdgm-prev-badge__stars, .jdgm-prev-badge__text';

  function headerOffset() {
    var root = getComputedStyle(document.documentElement);
    var raw = root.getPropertyValue('--header-height') || '';
    var parsed = parseInt(raw, 10);
    // Fall back to Judge.me's own 30px intent plus breathing room when the theme
    // has not published a header height (e.g. a non-sticky header).
    return (isNaN(parsed) ? 80 : parsed) + 16;
  }

  document.addEventListener('click', function (event) {
    var badge = event.target.closest(BADGE_SELECTOR);
    if (!badge) return;

    var widget = document.querySelector(WIDGET_SELECTOR);
    if (!widget) return;

    event.preventDefault();

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var top = widget.getBoundingClientRect().top + window.scrollY - headerOffset();

    window.scrollTo({ top: top < 0 ? 0 : top, behavior: reduce ? 'auto' : 'smooth' });
  });

  // Keyboard parity: Judge.me gives the stars role="button" and tabindex="0" but no
  // key handling, so Enter/Space would otherwise do nothing for keyboard users.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
    var badge = event.target.closest && event.target.closest(BADGE_SELECTOR);
    if (!badge) return;
    event.preventDefault();
    badge.click();
  });
})();
